export default "__VITE_ASSET__Ccsy9jLH__"